export const WALLET_TYPES = {
  inPageProvider: 'inPageProvider',
  ledger: 'ledger',
  trezor: 'trezor',
  walletConnect: 'walletConnect',
  portis: 'portis',
  fortmatic: 'fortmatic',
  coinbase: 'coinbase',
  binance: 'binance',
  clover: 'clover',
} as const;

export type TWalletType = (typeof WALLET_TYPES)[keyof typeof WALLET_TYPES];

interface ThdDerivationPath {
  name: string,
  value: string
}

interface IhdDetivationPath {
  [key: string]: ThdDerivationPath
}

export const HD_DERIVATION_PATHS: IhdDetivationPath = {
  LIVE: {
    name: 'Ledger Live',
    value: '44\'/60\'/x\'/0/0',
  },
  LEGACY: {
    name: 'Legacy (MEW / MyCrypto)',
    value: '44\'/60\'/0\'/x',
  },
};

export const TREZOR_PATHS: IhdDetivationPath = {
  LIVE: {
    name: 'Trezor Connect',
    value: 'm/44\'/60\'/0\'/0/x',
  },
};

export const CONNECTION_ERROR_ADDITIONS = {
  [WALLET_TYPES.coinbase]: '',
};

export const LEDGER_LS_KEY = 'fd8624a1-a9c8-4444-a629-527eeade865b';
export const TREZOR_LS_KEY = 'c4f96f6d-9048-4679-bad9-529f64b389da';
export const INPAGE_KEY = '63b16228-dfcb-46c0-969c-3b13b2acad7d';

export const NOT_SUPPORTED_WALLETS_LINKS: any = {
  mobile: {
    metamask: {
      iOS: 'https://apps.apple.com/us/app/metamask/id1438144202?_branch_match_id=863004636459437586',
      Android: 'https://play.google.com/store/apps/details?id=io.metamask&hl=en_US&ref=producthunt&_branch_match_id=863004636459437586',
    },
    trust: {
      iOS: 'https://apps.apple.com/us/app/trust-crypto-bitcoin-wallet/id1288339409',
      Android: 'https://play.google.com/store/apps/details?id=com.wallet.crypto.trustapp&hl=en&gl=US',
    },
    mathWallet: {
      iOS: 'https://apps.apple.com/us/app/math-wallet-blockchain-wallet/id1383637331',
      Android: 'https://play.google.com/store/apps/details?id=com.medishares.android&hl=en&gl=US',
    },
    safePal: {
      iOS: 'https://apps.apple.com/us/app/safepal-crypto-wallet-btc/id1449232593',
      Android: 'https://play.google.com/store/apps/details?id=io.safepal.wallet&hl=en&gl=US',
    },
    tokenPocket: {
      iOS: 'https://apps.apple.com/us/app/tokenpocket/id1436028697',
      Android: 'https://play.google.com/store/apps/details?id=vip.mytokenpocket&hl=en&gl=US',
    },
  },
  browser: {
    metamask: {
      Chrome: 'https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn',
      Firefox: 'https://addons.mozilla.org/en-US/firefox/addon/ether-metamask/',
      Brave: 'https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn',
      Edge: 'https://microsoftedge.microsoft.com/addons/detail/metamask/ejbalbakoplchlghecdalmeeeajnimhm?hl=en-US',
    },
    mathWallet: {
      Chrome: 'https://chrome.google.com/webstore/detail/math-wallet/afbcbjpbpfadlkmhmclhkeeodmamcflc?hl=en',
    },
  },
};

export const WALLET_KEYS_TO_NAME : any = {
  metamask: 'MetaMask',
  trust: 'Trust',
  mathWallet: 'Math Wallet',
  safePal: 'SafePal',
  tokenPocket: 'TokenPocket',
  binance: 'Binance Chain Wallet',
};
